import AXIOS from '../../../api/http-axios'
import { ToastProgrammatic as Toast } from 'buefy'

const getDefaultState = () => {
  return {
    /* Global loading status */
    status: 0,
    /** List of plannings */
    plannings: [],
    selectedPlanning: null,
    /** List of routes (separated from the planning) */
    routes: [],
    /** List of point of delivery to move to a route */
    pods: [],
    /** List of vehicles */
    vehicles: [],
    /** Filters */
    criteria: {
    /* Route filters */
      routes: {
        name: '',
        departurehour: '',
        tags: [],
        days: []
      }
    }
  }
}

const state = getDefaultState

const getters = {

  /** @return true if status after request for invoice list is 'loading' */
  isLoading: state => state.status !== 0,

  /** Flag for route filter */
  isRouteFiltering: state => {
    let isFiltered = false
    isFiltered |= state.criteria.routes.name !== ''
    isFiltered |= state.criteria.routes.departurehour !== '' && state.criteria.routes.departurehour != null
    isFiltered |= state.criteria.routes.tags.length !== 0
    isFiltered |= state.criteria.routes.days.length !== 0
    return isFiltered
  },

  /** Get all plannings */
  plannings: state => state.plannings,

  /** Get all vehicles */
  vehicles: state => state.vehicles,

  /** Get Planning by ID */
  planning: state => planningId => {
    let localPlanning = {}
    state.plannings.forEach(e => {
      if (e.id === planningId) {
        localPlanning = e
        return true
      }
    })
    return localPlanning
  },
  selectedPlanning: state => state.selectedPlanning,

  /** Get point of delivery for a planning */
  pods: state => planningId => {
    let pods = []
    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        // All Pods
        pods = e.data
        return true
      }
    })
    return pods
  },

  /**
   * Get pod from main pods list
   */
  pod: state => planningId => siteCode => {
    let pod = {}
    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(p => {
          if (p.site.code === siteCode) {
            pod = p
          }
          return true
        })
        return true
      }
    })
    return pod
  },

  /** Get all routes for a planning */
  routes: state => planningId => {
    let localRoutes = []
    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        // return a copy the route
        localRoutes = filteredRoute(state.criteria.routes, JSON.parse(JSON.stringify(e.data)))
      }
    })
    return localRoutes
  },

  /** Get all pods for a route */
  routepods: state => planningId => routeId => {
    let localPods = []
    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            if (r.pods) {
              localPods = r.pods
            }
            return true
          }
        })
      }
    })
    return localPods
  },

  /** Get filtered pods for a route */
  filteredroutepods: state => planningId => routeId => {
    let localPods = []
    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            if (r.pods) {
              localPods = filteredRoutePod(state.criteria.routes, JSON.parse(JSON.stringify(r)))
            }
            return true
          }
        })
      }
    })
    return localPods
  },

  /**
   * Get pod from route pods list
   */
  routepod: state => planningId => routeId => podId => {
    let pod = {}
    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            r.pods.forEach(p => {
              if (p.id === podId) {
                pod = p
              }
              return true
            })
            return true
          }
        })
      }
    })
    return pod
  }
}

/**
 * Store Mutations
 * Doing mutations directly from vues is deprecated
 * Mutation must be done only with actions
 */
const mutations = {
  setStartLoadingStatus: (state) => {
    state.status += 1
  },
  setStopLoadingStatus: (state) => {
    state.status -= 1
  },

  setPlannings: (state, plannings) => {
    state.plannings = plannings
  },
  addPlanning: (state, planning) => {
    state.plannings.push(planning)
  },
  updatePlanning: (state, planning) => {
    state.plannings = state.plannings.map(function (p) {
      return p.id === planning.id ? planning : p
    })
  },
  deletePlanning: (state, planningId) => {
    state.plannings = state.plannings.filter(p => {
      return p.id !== planningId
    })
    state.routes = state.routes.filter(p => {
      return p.id !== planningId
    })
  },
  setSelectedPlanning: (state, planning) => {
    state.selectedPlanning = planning
  },
  setPods: (state, pods) => {
    state.pods = pods
  },
  addPod: (state, params) => {
    const planningId = params[0]
    const pod = params[1]

    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        e.data.push(pod)
        return true
      }
    })
  },
  updatePods: (state, params) => {
    const planningId = params[0]
    const pods = params[1]

    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        e.data = pods
        return true
      }
    })
  },
  deletePod: (state, params) => {
    const planningId = params[0]
    const pod = params[1]

    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        e.data = e.data.filter(p => {
          return p.id !== pod.id
        })
        return true
      }
    })
  },
  mergePods: ({ commit, state }, params) => {
    const planningId = params[0]
    const pods = params[1]

    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        pods.forEach(function (pod) {
          for (let index = 0; index < e.data.length; index++) {
            const oldPod = e.data[index]
            if (pod.site.code === oldPod.site.code) {
              return mergePod(pod, oldPod)
            }
          }
          return pod
        })
      }
    })
    commit('updatePods', params)
  },

  setRoutes: (state, routes) => {
    state.routes = routes
  },
  addRoute: (state, params) => {
    const planningId = params[0]
    const route = params[1]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.push(route)
      }
    })
  },
  updateRoute: (state, params) => {
    const planningId = params[0]
    const route = params[1]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data = e.data.map(function (r) {
          return r.id === route.id ? route : r
        })
      }
    })
  },
  deleteRoute: (state, params) => {
    const planningId = params[0]
    const routeId = params[1]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data = e.data.filter(r => {
          return r.id !== routeId
        })
      }
    })
  },

  updatePodRoute: (state, params) => {
    const planningId = params[0]
    const routeId = params[1]
    const pod = params[2]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            r.pods = r.pods.map(function (p) {
              return p.id === pod.id ? pod : p
            })
          }
        })
        return true
      }
    })
  },
  mergePodRoute: (state, params) => {
    const planningId = params[0]
    const newPod = params[1]

    state.pods.forEach(e => {
      if (e.planningId === planningId) {
        let add = true

        e.data = e.data.map(function (pod) {
          if (pod.site.code === newPod.site.code) {
            add = false
            return mergePod(pod, newPod)
          }
          return pod
        })
        if (add) {
          e.data.push(newPod)
        }
        return true
      }
    })
  },
  deletePodFromRoutes: (state, params) => {
    const planningId = params[0]
    const routeId = params[1]
    const podId = params[2]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            r.pods = r.pods.filter(p => {
              return p.id !== podId
            })
          }
        })
        return true
      }
    })
  },
  addPodsToRoutes: (state, params) => {
    const planningId = params[0]
    const routeId = params[1]
    const pods = params[2]

    state.routes.forEach(e => {
      if (e.planningId === planningId) {
        e.data.forEach(r => {
          if (r.id === routeId) {
            r.pods = pods
          }
        })
        return true
      }
    })
  },

  setVehicles: (state, vehicles) => {
    state.vehicles = vehicles
  },
  addVehicle: (state, vehicle) => {
    state.vehicles.push(vehicle)
  },
  updateVehicle: (state, vehicle) => {
    state.vehicles = state.vehicles.map(function (v) {
      return v.id === vehicle.id ? vehicle : v
    })
  },
  deleteVehicle: (state, vehicleId) => {
    state.vehicles = state.vehicles.filter(v => {
      return v.id !== vehicleId
    })
  },

  searchPods: (state, podName) => {
    state.criteria.pods.name = podName
  },
  searchRoutes: (state, routeCriteria) => {
    state.criteria.routes = routeCriteria
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  retrieveAllVehicles: async ({ commit }) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.get('vehicles')
      commit('setVehicles', response.data)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error getting vehicles.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  addVehicle: async ({ commit }, vehicle) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('vehicles', [vehicle])
      commit('addVehicle', response.data[0])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error adding vehicle.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  updateVehicle: async ({ commit }, vehicle) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('vehicles', [vehicle])
      commit('updateVehicle', response.data[0])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error updating vehicle.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  deleteVehicle: async ({ commit }, vehicleId) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.delete('vehicles/' + vehicleId)
      commit('deleteVehicle', vehicleId)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error deleting vehicle.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },

  retrieveAllPlannings: async ({ commit }) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.get('plannings')
      commit('setPlannings', response.data)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error getting plannings.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  retrieveExportXlsPlanning: async ({ commit }, planning) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.get('plannings/export/' + planning.id, { responseType: 'blob' })
      const filename = planning.name + '_' + new Date().getTime() + '.xls'
      if (!window.navigator.msSaveOrOpenBlob) {
        // BLOB NAVIGATOR
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      } else {
        // BLOB FOR EXPLORER 11
        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename)
      }
    } catch (error) {
      Toast.open({ message: 'Error exporting plannings XLS.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  addPlanning: async ({ commit }, planning) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('plannings', [planning])
      commit('addPlanning', response.data[0])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error adding new planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  updatePlanning: async ({ commit }, planning) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('plannings', [planning])
      commit('updatePlanning', response.data[0])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error updating planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  deletePlanning: async ({ commit }, planningId) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.delete('plannings/' + planningId)
      commit('deletePlanning', planningId)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error deleting planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  duplicatePlanning: async ({ commit, dispatch }, planning) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('plannings/' + planning.id + '/duplicate', null, {
        params: {
          startDayInYear: planning.startDayInYear,
          endDayInYear: planning.endDayInYear,
          fixOverlapping: planning.fixOverlapping
        }
      })
      commit('setSelectedPlanning', response.data)
      dispatch('retrieveAllPlannings')
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error duplicating planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  importCSVPlanning: async ({ commit, dispatch }, importedData) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.post('plannings/import', importedData)
      dispatch('retrieveAllPlannings')
      dispatch('retrieveAllVehicles')
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error importing csv plannings.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },

  searchPods: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      const planningId = params[0]
      const criteriaPodName = params[1]
      const response = await AXIOS.get('customersPods/search/' + planningId + '?query=' + criteriaPodName)
      commit('setPods', [{ planningId: planningId, data: response.data }])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while searching pods.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  retrieveAllPods: async ({ commit }, planningId) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.get('customersPods/' + planningId)
      commit('setPods', [{ planningId: planningId, data: response.data }])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while getting main list of pods for planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  retrieveAllRoutesForPlanning: async ({ commit }, planningId) => {
    try {
      commit('setStartLoadingStatus')
      const response = await AXIOS.get('plannings/' + planningId + '/routes')
      commit('setRoutes', [{ planningId: planningId, data: response.data }])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while getting routes for planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  addRouteToPlanning: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      const planningId = params[0]
      const route = params[1]
      const response = await AXIOS.post('plannings/' + planningId + '/routes', [route])
      commit('addRoute', [planningId, response.data[0]])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while adding route to planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  updateRouteForPlanning: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      const planningId = params[0]
      const route = params[1]
      const response = await AXIOS.post('plannings/' + planningId + '/routes', [route])
      commit('updateRoute', [{ planningId: planningId, data: response.data }])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while updating route for planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  deleteRouteForPlanning: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      // const planningId = params[0]
      const routeId = params[1]
      const response = await AXIOS.delete('plannings/routes/' + routeId)
      commit('deleteRoute', params)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while deleting route for planning.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },

  updatePodRoutes: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      // const planningId = params[0]
      // const routeId = params[1]
      const pod = params[2]
      const response = await AXIOS.put('plannings/routes/pods/' + pod.id, pod)
      commit('updatePodRoute', [params[0], params[1], response.data])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while updating pods for routes.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  deletePodRoutes: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      // const planningId = params[0]
      // const routeId = params[1]
      const pod = params[2]
      const response = await AXIOS.delete('plannings/routes/pods/' + pod.id)
      commit('deletePodFromRoutes', params)
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while deleting pod for routes.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },
  addPodsToRoute: async ({ commit }, params) => {
    try {
      commit('setStartLoadingStatus')
      const planningId = params[0]
      const routeId = params[1]
      const pods = params[2]
      const response = await AXIOS.post('plannings/routes/' + routeId + '/pods/', pods)
      commit('addPodsToRoutes', [planningId, routeId, response.data])
      return Promise.resolve(response)
    } catch (error) {
      Toast.open({ message: 'Error while adding pods to route.', type: 'is-danger' })
      return Promise.reject(error)
    } finally {
      commit('setStopLoadingStatus')
    }
  },

  resetState ({ commit }) {
    commit('resetState')
  }
}

/***
 * Merge pod days
 */
function mergePod (oldPod, newPod) {
  if (oldPod.days && oldPod.days.length === 7 && newPod.days && newPod.days.length === 7) {
    for (let i = 0; i < oldPod.days.length; i++) {
      oldPod.days[i] |= newPod.days[i]
    }
  }
  return oldPod
}

function filteredRoute (routeCriteria, data) {
  let filteredRoutes = data
  // Filter by name
  if (routeCriteria.name && routeCriteria.name !== '') {
    filteredRoutes = filteredRoutes.filter(route => {
      if (route.name.toLowerCase().includes(routeCriteria.name.toLowerCase())) {
        return route
      }
    })
  }

  // Filter by hour
  if (routeCriteria.departurehour) {
    const departureDate = new Date(routeCriteria.departurehour)
    filteredRoutes = filteredRoutes.filter(route => {
      const date = new Date()
      const hours = route.departureHour / 60
      const minutes = route.departureHour % 60
      date.setHours(hours)
      date.setMinutes(minutes)
      // console.log("date <= routeCriteria.departurehour :" + date <= departureDate)
      // console.log("date :" + date)
      // console.log("routeCriteria.departurehour :" + departureDate)
      if (date >= departureDate) {
        return route
      }
    })
  }

  // Filter by tags
  if (routeCriteria.tags && routeCriteria.tags.length !== 0) {
    // console.log("Criteria tags to filter " + JSON.stringify(routeCriteria.tags))
    filteredRoutes = filteredRoutes.filter(route => {
      let includeTag = false
      routeCriteria.tags.forEach(t => {
        includeTag |= route.tags ? route.tags.includes(t) : false
      })
      if (includeTag) {
        return route
      }
    })
  }

  // Filter by days
  if (routeCriteria.days && routeCriteria.days.length !== 0) {
    // console.log("Criteria days to filter " + JSON.stringify(routeCriteria.days))
    filteredRoutes = filteredRoutes.filter(route => {
      if (!route.pods || route.pods.length === 0) {
        return route
      } else {
        // Filter
        let keepRoute = false
        route.pods.forEach(p => {
          for (let i = 0; i < 7; i++) {
            if (p.days[i] & routeCriteria.days[i]) {
              keepRoute = true
            }
          }
        })
        if (keepRoute) {
          return route
        }
      }
    })
  }
  return filteredRoutes
}

function filteredRoutePod (routeCriteria, route) {
  let isFiltered = false
  for (let i = 0; i < 7; i++) {
    if (routeCriteria.days[i]) {
      isFiltered = true
    }
  }
  if (isFiltered) {
    return route.pods.filter(p => {
      for (let i = 0; i < 7; i++) {
        // pod match
        if (p.days[i] & routeCriteria.days[i]) {
          return p
        }
      }
    })
  } else {
    return route.pods
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
